import React, { Fragment, useContext, useEffect, useState } from "react";
//import "primereact/resources/themes/mdc-light-indigo/theme.css";
import "primereact/resources/themes/saga-blue/theme.css";
//import "primereact/resources/themes/lara-light-blue/theme.css"
//import "primereact/resources/themes/fluent-light/theme.css";

import "primeicons/primeicons.css";
import "primereact/resources/primereact.min.css";
import "remixicon/fonts/remixicon.css";
import "../../assets/_overrides.scss";
import "/node_modules/primeflex/primeflex.css";

import { observer } from "mobx-react-lite";
import { Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Login from "../../scene-d/Login/Login";
import NoAccess from "../../scene-d/NoAccess/NoAccess";
import agent from "../api/agent";
import { RootStoreContext } from "../stores/rootStore";
import { appConfig } from "../../config";
import AppAdmin from "./AppAdmin";
import AppBeta from "./AppBeta";
import AppDefault from "./AppDefault";
import AppDeveloper from "./AppDeveloper";
import AppProjectManagement from "./AppProjectManagement";
import AppTools from "./AppTools";
import CompoundVerify from "../../screen-tools/Compounds/CompoundVerify/CompoundVerify";
import MoleculeEditor from "../../screen-tools/MoleculeEditor/MoleculeEditor";
import Reinvent4Dash from "../../screen-tools/Reinvent4/Reinvent4Dash";
import NetworkError from "./Errors/NetworkError/NetworkError";
import Footer from "./Footer/Footer";
import Loading from "./Loading/Loading";
import NotFound from "./NotFound/NotFound";
import TitleBar from "./TitleBar/TitleBar";

const App = () => {
  const authServiceInstance = agent.AuthServiceInstance;

  const rootStore = useContext(RootStoreContext);
  const { user, getUser, fetching, userNotFound } = rootStore.userStore;
  const { adminMode } = rootStore.appSettingsStore;
  const { fetchingAppVars, appVars, fetchAppVars } = rootStore.generalStore;
  const [networkErr, setNetworkErr] = useState(false);

  const skipAuth = appConfig.SKIP_AUTH === true;

  useEffect(() => {
    // Always fetch appVars (branding settings) even when not logged in
    if (appVars === null) {
      fetchAppVars();
    }

    if (skipAuth) {
      return;
    }

    if (authServiceInstance.account && !networkErr && !user && !userNotFound) {
      getUser().catch((e) => {
        console.error("CAUGHT NETWORK ERROR");
        setNetworkErr(true);
      });
    }
  }, [
    getUser,
    networkErr,
    user,
    userNotFound,
    authServiceInstance.account,
    adminMode,
    appVars,
    fetchAppVars,
    skipAuth,
  ]);

  if (networkErr) {
    return <NetworkError />;
  }

  if (fetching || fetchingAppVars) {
    return <Loading />;
  }

  if (!skipAuth && userNotFound) {
    return <NoAccess />;
  }

  // In skip-auth mode, bypass login and go directly to main app
  if (skipAuth) {
    return (
      <Fragment>
        <ToastContainer pauseOnHover theme="light" />

        <Routes>
          {/* Verify page — with TitleBar and Footer, no MenuBarTools */}
          <Route path="/tools/verify" element={
            <div className="flex flex-column">
              <div className="block">
                <TitleBar />
              </div>
              <div className="block overflow-auto">
                <CompoundVerify />
              </div>
              <div className="flex">
                <Footer />
              </div>
            </div>
          } />
          <Route path="/tools/verify/*" element={
            <div className="flex flex-column">
              <div className="block">
                <TitleBar />
              </div>
              <div className="block overflow-auto">
                <CompoundVerify />
              </div>
              <div className="flex">
                <Footer />
              </div>
            </div>
          } />

          {/* Editor page — with TitleBar and Footer, no MenuBarTools */}
          <Route path="/tools/editor" element={
            <div className="flex flex-column">
              <div className="block">
                <TitleBar />
              </div>
              <div className="block overflow-auto">
                <MoleculeEditor />
              </div>
              <div className="flex">
                <Footer />
              </div>
            </div>
          } />
          <Route path="/tools/editor/*" element={
            <div className="flex flex-column">
              <div className="block">
                <TitleBar />
              </div>
              <div className="block overflow-auto">
                <MoleculeEditor />
              </div>
              <div className="flex">
                <Footer />
              </div>
            </div>
          } />

          {/* Molecular Design page — with TitleBar and Footer, no MenuBarTools */}
          <Route path="/tools/moldesign" element={
            <div className="flex flex-column">
              <div className="block">
                <TitleBar />
              </div>
              <div className="block overflow-auto">
                <Reinvent4Dash />
              </div>
              <div className="flex">
                <Footer />
              </div>
            </div>
          } />
          <Route path="/tools/moldesign/*" element={
            <div className="flex flex-column">
              <div className="block">
                <TitleBar />
              </div>
              <div className="block overflow-auto">
                <Reinvent4Dash />
              </div>
              <div className="flex">
                <Footer />
              </div>
            </div>
          } />

          {/* All other pages — with TitleBar and Footer */}
          <Route path="*" element={
<div className="flex flex-column">
              <div className="block">
                <TitleBar />
              </div>
              <div className="block overflow-auto">
                <Routes>
                  <Route index element={<Navigate replace to="/d/" />} />
                  <Route path="/d/*" element={<AppDefault />} />
                  <Route path="/admin/*" element={<AppAdmin />} />
                  <Route path="/pm/*" element={<AppProjectManagement />} />
                  <Route path="/beta" element={<AppBeta />} />
                  <Route path="/developer/*" element={<AppDeveloper />} />
                  <Route path="/tools/*" element={<AppTools />} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </div>
              <div className="flex">
                <Footer />
              </div>
            </div>
          } />
        </Routes>
      </Fragment>
    );
  }

  let signedInRender = (
    <Fragment>
      <ToastContainer pauseOnHover theme="light" />

      <Routes>
        {/* Verify page — with TitleBar and Footer, no MenuBarTools */}
        <Route path="/tools/verify" element={
          <div className="flex flex-column">
            <div className="block">
              <TitleBar />
            </div>
            <div className="block overflow-auto">
              <CompoundVerify />
            </div>
            <div className="flex">
              <Footer />
            </div>
          </div>
        } />
        <Route path="/tools/verify/*" element={
          <div className="flex flex-column">
            <div className="block">
              <TitleBar />
            </div>
            <div className="block overflow-auto">
              <CompoundVerify />
            </div>
            <div className="flex">
              <Footer />
            </div>
          </div>
        } />

        {/* Editor page — with TitleBar and Footer, no MenuBarTools */}
        <Route path="/tools/editor" element={
          <div className="flex flex-column">
            <div className="block">
              <TitleBar />
            </div>
            <div className="block overflow-auto">
              <MoleculeEditor />
            </div>
            <div className="flex">
              <Footer />
            </div>
          </div>
        } />
        <Route path="/tools/editor/*" element={
          <div className="flex flex-column">
            <div className="block">
              <TitleBar />
            </div>
            <div className="block overflow-auto">
              <MoleculeEditor />
            </div>
            <div className="flex">
              <Footer />
            </div>
          </div>
        } />

        {/* Molecular Design page — with TitleBar and Footer, no MenuBarTools */}
        <Route path="/tools/moldesign" element={
          <div className="flex flex-column">
            <div className="block">
              <TitleBar />
            </div>
            <div className="block overflow-auto">
              <Reinvent4Dash />
            </div>
            <div className="flex">
              <Footer />
            </div>
          </div>
        } />
        <Route path="/tools/moldesign/*" element={
          <div className="flex flex-column">
            <div className="block">
              <TitleBar />
            </div>
            <div className="block overflow-auto">
              <Reinvent4Dash />
            </div>
            <div className="flex">
              <Footer />
            </div>
          </div>
        } />

        {/* All other pages — with TitleBar and Footer */}
        <Route path="*" element={
        <div className="flex flex-column">
            <div className="block">
              <TitleBar />
            </div>
            <div className="block overflow-auto">
              <Routes>
                <Route index element={<Navigate replace to="/d/" />} />
                <Route path="/d/*" element={<AppDefault />} />
                <Route path="/admin/*" element={<AppAdmin />} />
                <Route path="/pm/*" element={<AppProjectManagement />} />
                <Route path="/beta" element={<AppBeta />} />
                <Route path="/developer/*" element={<AppDeveloper />} />
                <Route path="/tools/*" element={<AppTools />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
            <div className="flex">
              <Footer />
            </div>
          </div>
        } />
      </Routes>
    </Fragment>
  );

  let notSignedInRender = (
    <Fragment>
      <Login
        loginButtonClicked={async () => await authServiceInstance.SignIn()}
      />
    </Fragment>
  );

  if (!user) {
    return notSignedInRender;
  }

  // Update browser tab title dynamically from brand config
  const siteName = rootStore?.generalStore?.appVars?.siteName;
  if (siteName && document.title !== siteName) {
    document.title = siteName;
  }

  if (user) {
    return signedInRender;
  }
};

export default observer(App);